<template>
    <div class="search">
        <div
                class="search__remove"
                v-if="search && btnClose"
                @mousedown="$event.preventDefault()"
                @click="clearInput">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.6894 0.321199C13.2753 -0.0929084 12.6064 -0.0929084 12.1923 0.321199L7 5.50284L1.80774 0.31058C1.39363 -0.103527 0.724687 -0.103527 0.31058 0.31058C-0.103527 0.724687 -0.103527 1.39363 0.31058 1.80774L5.50284 7L0.31058 12.1923C-0.103527 12.6064 -0.103527 13.2753 0.31058 13.6894C0.724687 14.1035 1.39363 14.1035 1.80774 13.6894L7 8.49716L12.1923 13.6894C12.6064 14.1035 13.2753 14.1035 13.6894 13.6894C14.1035 13.2753 14.1035 12.6064 13.6894 12.1923L8.49716 7L13.6894 1.80774C14.0929 1.40425 14.0929 0.724687 13.6894 0.321199Z" fill="#01254E"/>
            </svg>
        </div>
        <input type="text" class="search__field"
               :placeholder="$t('search.zip_placeholder')"
               @input="inputHandler($event.target.value)"
               @focus="focusHandler"
               @blur="blurHandler"
               @keyup.enter="select"
               @keydown.tab="select"
               @keydown.down="onDown"
               @keydown.up="onUp"
               @keyup.esc="isOpened = false"
               :class="fieldsClass"
               ref="dropdown"
               v-model="search"/>
        <div class="search__icon">
            <svg width="14" height="14" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.2022 15.931L14.2023 15.9312C14.3997 16.1362 14.6669 16.25 14.9517 16.25C15.2212 16.25 15.478 16.1469 15.6724 15.9598C16.0857 15.5621 16.0989 14.9031 15.7012 14.4894L15.5209 14.6626L15.7012 14.4894L12.2842 10.9356C13.1497 9.82936 13.6218 8.46916 13.6218 7.05624C13.6218 3.57881 10.793 0.75 7.31552 0.75C3.83809 0.75 1.00928 3.57881 1.00928 7.05624C1.00928 10.5337 3.83809 13.3625 7.31552 13.3625C8.54845 13.3625 9.72769 13.0109 10.7511 12.3417L14.2022 15.931ZM7.31552 2.82989C9.64577 2.82989 11.5419 4.726 11.5419 7.05624C11.5419 9.38649 9.64577 11.2826 7.31552 11.2826C4.98528 11.2826 3.08917 9.38649 3.08917 7.05624C3.08917 4.726 4.98528 2.82989 7.31552 2.82989Z" fill="#D7DDE1" stroke="#D7DDE1" stroke-width="0.5"/>
            </svg>
        </div>
        <transition	name="fade" mode="in-out">
            <ul class="options-list" v-show="isOpened && filteredItems.length">
                <li class="options-list__item" v-for="(option, i) in filteredItems"
                    :key="i"
                    @mouseenter="selected = i"
                    @mousedown="select"
                    :class="{'selected': i === selected}">
                    {{ option.name }}
                    <!--<slot name="item" :title="option.name" :thumbnail="option.thumbnail">-->
                </li>
            </ul>
        </transition>
    </div>
</template>
<script>
    import { debounce } from '@/helpers/debounce'
    export default {
        data() {
            return {
                isOpened: false,
                selected: null,
                focused: '',
                btnClose: false,
                search: "",
                options: []
            };
        },
        methods: {
            btnCloseState(state) {
                this.btnClose = state;
            },
            inputHandler(value) {
                this.isOpened = !!value; //(value != '');
                this.focused = !!value;
                this.selected = null;
                this.btnCloseState(true)
                if(this.isOpened) this.fetchSuggestionsDebounce();
            },
            saveSuggestions(suggestions) {
              this.options = suggestions;
            },
            clearInput() {
                this.search = '';
                this.options = []
                this.blurHandler()
                this.removeSearchMarker();
            },
            select() {
                if(!this.selected && this.filteredItems.length) {
                    this.selected = 0;
                }
                if(!this.filteredItems.length || this.search.length < 1) return;
                const selectedOption = this.filteredItems[this.selected];
                this.search = selectedOption.name;
                const points = selectedOption.point;
                this.isOpened = false;
                this.blurHandler()
                this.btnCloseState(false)
                this.savePoints(points)
            },
            savePoints(points) {
              this.$store.dispatch('FLY_MAP', points)
            },
            removeSearchMarker() {
              this.$store.commit('REMOVE_SEARCH_MARKER')
            },
            onDown() {
                if (!this.isOpened) {
                    return;
                }
                this.selected = (this.selected + 1) % this.filteredItems.length;
            },
            onUp() {
                if (!this.isOpened) {
                    return;
                }

                this.selected =
                    this.selected - 1 < 0
                        ? this.filteredItems.length - 1
                        : this.selected - 1;
            },
            focusHandler(){
                this.focused = true
                if(this.search.length > 0) {
                    if(this.options.length > 0) {
                        this.isOpened = true;
                    }
                    if(!this.btnClose) {
                        this.btnCloseState(true)
                    }
                }
            },
            blurHandler() {
                this.focused = this.isOpened = false
                if(this.btnClose) {
                    this.btnCloseState(false)
                }
            },
            async fetchSuggestions() {
                try {
                    let response = await this.$store.dispatch('search', this.searchInLowerCase)
                    this.saveSuggestions(response.data.data.suggestions)
                }catch(e) {
                    console.log(e, 'error')
                }
            }
        },
        computed: {
            fieldsClass() {
              return {
                  'is-focus': this.focused,
                  'is-active': !this.focused
              }
            },
            fetchSuggestionsDebounce() {
                let delay = 400;
                return debounce(this.fetchSuggestions, delay)
            },
            searchInLowerCase() {
                return this.search.toLowerCase().trim();
            },

            filteredItems() {
//                const condition = new RegExp(this.search, "i");
                const filtered = [];
                for (const option of this.options) {
//                    if (this.search.length < 1 || option.name.match(condition)){
                        if (filtered.length < 5) filtered.push(option);
//                    }
                }
//                console.log(filtered, 'filtered')
                return filtered;
//                console.log(this.options.filter(item => item.name.match(condition)));
//                return this.options.filter(item => item.name.match(condition));
            }
        },
    }
</script>

<style lang="sass">
    .search
        margin-left: 17px
        margin-top: -4px
        width: 260px
        position: relative
        &__icon
            position: absolute
            top: 50%
            left: 12px
            transform: translateY(-50%)
            display: flex
            opacity: 1
            visibility: visible
            transition: opacity .2s ease, visibility .2s ease
        &__field
            color: rgba($color--dark, 0.5)
            +reg
            width: 100%
            font-size: 15px
            line-height: 24px
            border: 1px solid rgba($color--dark, 0.25)
            border-radius: 4px
            outline: 0
            height: 48px
            padding: 0 25px 0 34px
            transition: padding-left .2s ease, border-color .3s ease, color .3s ease
            ::-webkit-input-placeholder
                color: rgba($color--dark, 0.5)
            &:hover,
            &.is-focus
                border-color: $color--blue
            &.is-focus,
            &.is-active
                color: $color--dark
            &.is-focus
                padding-left: 12px
                ~ .search__icon
                    opacity: 0
                    visibility: hidden
        &__remove
            font-size: 19px
            color: $color--dark
            cursor: pointer
            top: 50%
            right: 10px
            position: absolute
            transform: translateY(-50%)
            z-index: 1
            transition: opacity .3s ease
            &:hover
                opacity: 0.7


    .options-list
        background: #FFFFFF
        box-shadow: 0px 2px 6px rgba(1, 37, 78, 0.4)
        border-radius: 4px
        max-height: 300px
        overflow-y: auto
        width: 100%
        position: absolute
        top: 100%
        z-index: 2
        margin-top: 8px
        padding: 0!important
        scrollbar-width: none
        &__item
            color: $color--dark
            display: flex
            cursor: pointer
            padding: 12px
            +tr(all .3s ease)
            &.selected
                background: rgba(44, 100, 255, 0.05)
            &:not(:first-child)
                border-top: 1px solid #D7DDE1
            &:first-child
                border-radius: 4px 4px 0px 0px
        &::-webkit-scrollbar
            width: 0
            background: $color--gray
            scrollbar-width: none
            display: none
        &::-moz-scrollbar,
        &::-o-scrollbar
            display: none
            scrollbar-width: none
        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar-thumb
            background-color: $color--gray
            -ms-overflow-style: none
            scrollbar-width: none
            display: none

    .fade-enter-active,
    .fade-leave-active
        transition: all 0.3s ease

    .fade-enter,
    .fade-leave-active
        opacity: 0
        will-change: opacity
        transform: translateY(-30px)


</style>